/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface WorkTitleAbbreviationDTO
 */
export interface WorkTitleAbbreviationDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkTitleAbbreviationDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkTitleAbbreviationDTO
     */
    abbreviation?: string;
}

/**
 * Check if a given object implements the WorkTitleAbbreviationDTO interface.
 */
export function instanceOfWorkTitleAbbreviationDTO(value: object): value is WorkTitleAbbreviationDTO {
    return true;
}

export function WorkTitleAbbreviationDTOFromJSON(json: any): WorkTitleAbbreviationDTO {
    return WorkTitleAbbreviationDTOFromJSONTyped(json, false);
}

export function WorkTitleAbbreviationDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkTitleAbbreviationDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'abbreviation': json['abbreviation'] == null ? undefined : json['abbreviation'],
    };
}

export function WorkTitleAbbreviationDTOToJSON(json: any): WorkTitleAbbreviationDTO {
    return WorkTitleAbbreviationDTOToJSONTyped(json, false);
}

export function WorkTitleAbbreviationDTOToJSONTyped(value?: WorkTitleAbbreviationDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'abbreviation': value['abbreviation'],
    };
}


